import { QProfileHeader, QProfileItem, QProfileMenu, QLink, QThemeProvider } from '@kw/quokka-ui';

interface IProps {
  anchorEl: HTMLDivElement;
  handleClose: () => void;
}

const defaultDocumentationCenterUrl = 'https://kryptowire.zendesk.com/auth/v2/login/continue_with_sso_tracking?remote_auth_id=35808239917719&role=consumer&return_to=https%3A%2F%2Fqscout.zendesk.com%2Fhc%2Fen-us%3Fbrand_id%3D15285973673879&brand_id=15285973673879';
const defaultCustomerSupportUrl ='https://kryptowire.zendesk.com/auth/v2/login/continue_with_sso_tracking?remote_auth_id=35808239917719&role=consumer&return_to=https%3A%2F%2Fqscout.zendesk.com%2Fhc%2Fen-us%2Frequests%3Fbrand_id%3D15285973673879&brand_id=15285973673879';


const zendeskSSOUrls = {
  documentationCenter: process.env.ZENDESK_DOCUMENTATION_CENTER_URL || defaultDocumentationCenterUrl,
  customerSupport: process.env.ZENDESK_CUSTOMER_SUPPORT_URL || defaultCustomerSupportUrl,
};

export default function HelpDropDownMenu({ anchorEl, handleClose }: IProps) {
  const helpOpen = Boolean(anchorEl);
  const helpId = helpOpen ? 'help-popover' : undefined;

  const openInNewTab = url => {
    window.open(url, '_blank').focus();
  };

  return (
    <QThemeProvider>
      <QProfileMenu
        id={helpId}
        anchorEl={anchorEl}
        open={helpOpen}
        onClose={handleClose}
        header={<QProfileHeader primary="Help" />}
        aria-label="help drop down menu"
        items={[
          <QProfileItem
            key="documentation_center"
            component={QLink}
            onClick={() => {
              // redirect through SAML to documentation center https://qscout.zendesk.com/hc/en-us with brand QScout
              openInNewTab(zendeskSSOUrls.documentationCenter);
            }}
            disableRipple
            target="_blank"
          >
            {'Documentation Center'}
          </QProfileItem>,
          <QProfileItem
            key="customer_support"
            component={QLink}
            onClick={() => {
              // redirect through SAML to customer support https://qscout.zendesk.com/hc/en-us/requests with brand QScout
              openInNewTab(zendeskSSOUrls.customerSupport);
            }}
            disableRipple
            target="_blank"
          >
            {'Customer Support'}
          </QProfileItem>,
        ]}
      />
    </QThemeProvider>
  );
}
